import React from 'react'
import { Navigate } from 'react-router-dom'
import useSign from './hook/useSign'

const PrivateRoute = ({ children }) => {
  // Retorna o contexto de autenticação
  const { Sign } = useSign()

  return Sign.signed ? children : <Navigate to="/login" replace />
}

export default PrivateRoute
